<div class="modal fade" videoPlayerModal #modal [id]="modalId" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-1">
        <div class="modal-header dirI">
          <h5 class="modal-title"> اشتراک گذاری فیلم </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div [formGroup]="mdlTempAccess" class="row gx-3 gy-4 p-2 mb-2 justify-content-between rounded">
            <div class="position-relative col-md-6 col-12">
              <label for="strFamily" class="text-danger">تاریخ شروع</label>
              <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">
                <input dir="ltr" type="text" formControlName="strSDate" class="form-control">
              </ng-persian-datepicker>
            </div>
            <div class="position-relative col-md-6 col-12">
              <label for="strFamily" class="text-danger">ساعت شروع</label>
              <div class="input-group clockpicker">

                <input type="text" class="form-control text-center" #startTime formControlName="strSTime">

                <span class="input-group-addon ">

                  <span class="glyphicon glyphicon-time"></span>

                </span>

              </div>

            </div>

            <div class="position-relative col-md-6 col-12">

              <label for="strFamily" class="text-danger">تاریخ پایان</label>

              <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">

                <input dir="ltr" type="text" formControlName="strEDate" class="form-control">

              </ng-persian-datepicker>

            </div>

            <div class="position-relative col-md-6 col-12">

              <label for="strFamily" class="text-danger">ساعت پایان</label>

              <div class="input-group clockpicker">

                <input type="text" class="form-control text-center" #endTime formControlName="strETime">

                <span class="input-group-addon ">

                  <span class="glyphicon glyphicon-time"></span>

                </span>

              </div>

            </div>

            <div class="position-relative col-md-6 col-12">

              <label for="strFamily" class="text-danger">موبایل (کاربری)</label>

              <input dir="ltr" type="text" maxlength="11" formControlName="strMobile" class="form-control">

            </div>

            <div class="position-relative col-md-6 col-12">

              <label for="strFamily" class="text-danger">رمز عبور</label>

              <input dir="ltr" type="text" formControlName="strPassword" class="form-control">

            </div>

          </div>

        </div>

        <div class="modal-footer">
          <div class="col-12 d-flex justify-content-start">
            <button type="button" class="btn btn-sm px-4" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' "
              (click)="new_TempAccess()">
              {{bEditMode ? 'ویرایش' : 'ذخیره' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
